import { ApiClient } from './ApiClient';
import { TokenProvider } from './ApiClient/ApiClient.types';

class ApiClientSingleton {
  private instance: ApiClient;

  constructor() {
    this.instance = new ApiClient();
  }

  getClient(): ApiClient {
    return this.instance;
  }

  setStore(store: any): void {
    this.instance.setStore(store);
  }

  setToken(token: string): void {
    this.instance.setToken(token);
  }

  setTokenProvider(provider?: TokenProvider): void {
    this.instance.setTokenProvider(provider);
  }

  clearToken(): void {
    this.instance.clearToken();
  }

  getStatus(): { hasStore: boolean; hasToken: boolean } {
    const token = this.instance.getToken();
    return {
      hasStore: this.instance.getCurrentConfig() !== null,
      hasToken: Boolean(token && token.trim()),
    };
  }

  isAuthenticated(): boolean {
    const token = this.instance.getToken();
    return Boolean(token && token.trim());
  }
}

const apiClientManager = new ApiClientSingleton();

export const apiClient = apiClientManager.getClient();
export const setApiClientStore = (store: any) => apiClientManager.setStore(store);
export const setApiClientToken = (token: string) => apiClientManager.setToken(token);
export const setApiClientTokenProvider = (provider?: TokenProvider) => apiClientManager.setTokenProvider(provider);
export const clearApiClientToken = () => apiClientManager.clearToken();
export const getApiClientStatus = () => apiClientManager.getStatus();
export const isApiClientAuthenticated = () => apiClientManager.isAuthenticated();
